import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import { stripHtmlTags } from './html';
export var getHtmlExcerpt = function getHtmlExcerpt(html, length) {
  var trailing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';
  var textDescription = stripHtmlTags(html);
  return textDescription.length <= length ? textDescription : "".concat(textDescription.slice(0, length)).concat(trailing);
};